<template>
  <h5 class="card-title mb-2 fw-bold fs-3">Loyalty Program Setup</h5>
  <p>
    Members earn
    {{ store.loyaltyProgramType === "points" ? "points" : "stamps" }} when they
  </p>

  <FlexRow class="gap-4">
    <FlexRow
      v-for="option in options"
      :key="option.value"
      class="justify-content-center align-items-center gap-2 flex-grow-1 card p-3 rounded-5 hover-shadow cursor-pointer"
      :class="{
        'border-black': selectedOption === option.value,
        border: selectedOption !== option.value,
      }"
      @click="selectedOption = option.value"
    >
      <component :is="option.icon" style="width: 10px"></component>
      <span>{{ option.label }}</span>
    </FlexRow>
  </FlexRow>

  <FlexRow
    class="w-full"
    :class="
      selectedOption === 'fixed'
        ? 'justify-content-end'
        : 'justify-content-start'
    "
    :style="selectedOption === 'fixed' ? 'margin-left: 3.3rem' : ''"
  >
    <FlexCol class="w-50 card mt-4 rounded-5 p-3 gap-3">
      <span class="text-muted">&bull; Members Earn</span>
      <FlexRow>
        <input type="text" class="text-input" v-model="points" />
        <span>{{
          store.loyaltyProgramType === "points" ? "Point(s)" : "Stamp(s)"
        }}</span>
      </FlexRow>
      <small v-if="points > stampCardStore.totalStamps" class="text-primary"
        >This value cannot be higher than 15 or the number of stamps
        required.</small
      >
      <span class="text-muted"
        >&bull;
        {{
          selectedOption === "dynamic"
            ? "For every"
            : "When they spend at least"
        }}</span
      >
      <FlexRow>
        <span>{{ currencySymbol(store.brandCurrency) }}</span>
        <CurrencyInput v-model="spending" class="text-input" />
        <span>{{
          selectedOption === "dynamic" ? "they spend" : "in 1 visit"
        }}</span>
      </FlexRow>
    </FlexCol>
  </FlexRow>

  <FlexRow class="gap-2 mt-4">
    <button
      class="btn btn-outline-light px-5"
      @click="store.goTo('RewardSetup')"
    >
      <i class="bi bi-arrow-left"></i>
    </button>
    <button
      class="btn btn-primary flex-grow-1"
      :disabled="
        !points ||
        points > stampCardStore.totalStamps ||
        !spending ||
        !selectedOption
      "
      @click="
        store.goTo('RewardSetup');
        store.brandPoints = Number(points);
        store.brandSpending = Number(spending);
        store.brandEarningSelection = selectedOption;
      "
    >
      Continue
    </button>
  </FlexRow>
</template>

<script setup>
import DollarSign from "@/reusables/DollarSign.vue";
import WalkingPerson from "@/reusables/WalkingPerson.vue";
import FlexRow from "@/components/layout/FlexRow.vue";
import { useBrandSetupStore } from "@/stores/brand";
import { onMounted, ref, watch } from "vue";
import FlexCol from "@/components/layout/FlexCol.vue";
import CurrencyInput from "@/reusables/CurrencyInput.vue";
import { useQuery } from "@urql/vue";
import { GET_CURRENCY_RATE } from "@/constants/graphql";
import { useStampCardStore } from "@/stores/stampCard";
import { currencySymbol } from "@/constants/country_currency";

const store = useBrandSetupStore();
const stampCardStore = useStampCardStore();

const options = [
  { label: "Spend at your store", value: "dynamic", icon: DollarSign },
  { label: "Visit your store", value: "fixed", icon: WalkingPerson },
];

const emit = defineEmits(["update-points"]);
const selectedOption = ref("");
const spending = ref("");
const points = ref("");

onMounted(() => {
  selectedOption.value = store.brandIndustry.mode;
  spending.value = store.brandSpending;
  points.value = store.brandPoints;
});
</script>

<style scoped>
.hover-shadow {
  transition: all 0.3s ease-in-out;
}
.hover-shadow:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
